import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import { DataTable } from "@cxagroup/casper";
import { Card } from "cxa-components";
import { isEmpty } from "cxa-utils";

const ClaimItemAccountsWidget = ({ headers, rows }) => {
  if (isEmpty(rows)) {
    return null;
  }

  return (
    <Card>
      <div className="apl-scroll-table">
        <DataTable headers={headers} rows={rows} />
      </div>
    </Card>
  );
};

ClaimItemAccountsWidget.propTypes = {
  intl: intlShape.isRequired,
  headers: PropTypes.array,
  rows: PropTypes.array,
};

export default ClaimItemAccountsWidget;



// WEBPACK FOOTER //
// ./components/claim/ClaimItemAccountsWidget.js